export default __webpack_public_path__ + "static/media/android.0a32e305.svg";